import React from 'react';
import TheftRecoveryProgress from './TheftRecoveryProgress';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TheftRecoveryEnding extends React.Component {
  render() {
    const {
      sharedProps: {
        item
      },
      caseData,
      caseActions
    } = this.props;
    const trMetadata = item?.data?.locator?.data?.theftRecoveryRequestMetadata;
    return /*#__PURE__*/_jsx(TheftRecoveryProgress, {
      caseData: caseData,
      caseActions: caseActions,
      requestMetadata: trMetadata
    });
  }
}